import TicketHttp from "../../ticketHttp";

class ScreenLayoutServices{

    static async getBookedScreenLayout(data){
        console.log("BookedScreenLayout data",data)
        return TicketHttp.post("/bookedScreenLayout/",data)
        // return TicketHttp.get("/bookedScreenLayout/screenLayout",data)
    }


    static async getSummary(data){
        console.log("getSummary data",data)
        return TicketHttp.get("/bookings/summary",data)
        // return TicketHttp.get("/bookedScreenLayout/screenLayout",data)
    }


    static async blockSeatForCruze(data){
        console.log("blockSeatForCruz data",data)
        return TicketHttp.post("/bookedScreenLayout/blockSeatForCruze",data)
        // return TicketHttp.get("/bookedScreenLayout/screenLayout",data)
    }

    
    static async unblockSeatForCruze(data){
        console.log("unblockSeatForCruze data",data)
        return TicketHttp.post("/bookedScreenLayout/unblockSeatForCruze",data)
        // return TicketHttp.get("/bookedScreenLayout/screenLayout",data)
    }

    // static async createScreenLayout(data){
    //     console.log("createScreenLayout data",data)
    //     // return TicketHttp.post("/bookedScreenLayout/unblockSeatForCruze",data)
    //     return TicketHttp.post("/bookedScreenLayout/create",data)
    // }

    static async createScreenLayout(data) {
        try {
          console.log("createScreenLayout data", data);
          const response = await TicketHttp.post("/bookedScreenLayout/create", data);
          console.log('response in the createScreenLayout',response);
          return response;
        } catch (error) {
            console.log('error in the resonse createScreenLayout',error)
          if (error.response && error.response.data) {
            return error.response.data; // Still return error object
          } else {
            console.error("Unexpected error in createScreenLayout:", error);
            throw new Error("Something went wrong while creating screen layout.");
          }
        }
      }
      

   
      static async cancelBooking(data){
        console.log("cancelBooking data",data)
        // return TicketHttp.post("/bookedScreenLayout/unblockSeatForCruze",data)
        return TicketHttp.post("/bookedScreenLayout/cancelbooking",data)
    }


    static async getShowTimings({ theatreId = '', showtimeId = '', date = '' }) {
      const query = `?theatreId=${encodeURIComponent(theatreId)}&showtimeId=${encodeURIComponent(showtimeId)}&date=${encodeURIComponent(date)}`;
      return TicketHttp.get(`/bookedScreenLayout/getShowTimes${query}`);
    }




    // router.post('/blockSeatForCruze',BookedScreenLayout.blockSeatForCruze);

    // router.post('/unblockSeatForCruze',BookedScreenLayout.unblockSeatForCruze);


    // static async getMovies(){
    //     return TicketHttp.get('/movies');
    // }
    // static async getTheatersAndShowTimings(id){
    //     return TicketHttp.get(`/theatres/${id}`);
    // }
    // // static async getDriverTripcount(id){
    // //     return Http.get(`/rider-trip-counts/${id}`);
    // // }
    // static async updateMovies(id,data){
    //     console.log("========================================data in the riderServices",data)
    //     return TicketHttp.update(`/riders/${id}`,data)
    // }
    // static async getAllDriverTripsCounts(){
    //     return TicketHttp.get("/rider-trip-counts");
    // }
    // static async getDriverEarnings(id){
    //     return TicketHttp.get(`/rider-earnings/${id}`);


    // }
    
}
export default ScreenLayoutServices